// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"308b17ca","152":"6909f9f6","431":"f51b3efb","489":"564dbae1","608":"b4479c41","787":"6bc7be54","880":"cf8409c1"}[chunkId] + ".chunk.js";
};